import { FooterLink } from './LoginFooter.types';

export const FOOTER_LINKS: FooterLink[] = [
  {
    text: 'Grafana',
    url: 'https://grafana.com/grafana',
    target: '_blank',
  },
  {
    text: 'Prometheus',
    url: 'https://prometheus.io',
    target: '_blank',
  },
  {
    text: 'Clickhouse',
    url: 'https://clickhouse.tech',
    target: '_blank',
  },
  {
    text: 'PostgreSQL',
    url: 'https://www.postgresql.org',
    target: '_blank',
  },
];
